import { cn } from '@/lib/utils';

export type ChartRange = '24h' | '7d' | '30d';

interface RangeToggleProps {
  value: ChartRange;
  onChange: (range: ChartRange) => void;
  className?: string;
}

const OPTIONS: { label: string; value: ChartRange }[] = [
  { label: '24h', value: '24h' },
  { label: '7d', value: '7d' },
  { label: '30d', value: '30d' },
];

export function RangeToggle({ value, onChange, className }: RangeToggleProps) {
  return (
    <div
      role="group"
      aria-label="Chart time range"
      className={cn('inline-flex rounded-md border border-border divide-x divide-border overflow-hidden', className)}
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={cn(
            'px-2 py-0.5 text-xs font-medium transition-colors',
            value === opt.value
              ? 'bg-primary text-primary-foreground'
              : 'bg-background text-muted-foreground hover:bg-muted',
          )}
          aria-pressed={value === opt.value}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
